import { Component } from 'react';
import PageMeta from './PageMeta';
import { Link } from 'react-router-dom';
import SakuraSep from './SakuraSep';
import BurstBtn from './BurstBtn';

/* ── SVG icons ────────────────────────────────────────────── */
const PhoneIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.1 10.82a19.79 19.79 0 01-3.07-8.67A2 2 0 012 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
const MailIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
const PinIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="2"/>
    </svg>
);
const ClockIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
        <polyline points="12 6 12 12 16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
const SendIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="22" y1="2" x2="11" y2="13" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        <polygon points="22 2 15 22 11 13 2 9 22 2" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

/* ── Info cards data ──────────────────────────────────────── */
const INFO_CARDS = [
    {
        icon: <PhoneIcon />,
        label: 'Điện Thoại',
        lines: ['(+84) 912 345 678', '(+84) 024 3826 1234'],
        gradient: 'linear-gradient(135deg, #e12454 0%, #223a66 100%)',
    },
    {
        icon: <MailIcon />,
        label: 'Email',
        lines: ['info@yosakoi.vn', 'support@yosakoi.vn'],
        gradient: 'linear-gradient(135deg, #2c5f7a 0%, #223a66 100%)',
    },
    {
        icon: <PinIcon />,
        label: 'Địa Chỉ',
        lines: ['Số 48 Hàng Bài, Hoàn Kiếm', 'Hà Nội, Việt Nam'],
        gradient: 'linear-gradient(135deg, #e12454 0%, #6b3f8c 100%)',
    },
];

/* ── Office hours ─────────────────────────────────────────── */
const HOURS = [
    { day: 'Thứ 2 – Thứ 6', time: '08:00 – 17:30', closed: false },
    { day: 'Thứ 7',          time: '08:00 – 12:00', closed: false },
    { day: 'Chủ Nhật',       time: 'Nghỉ',          closed: true  },
];

/* ── Social links ─────────────────────────────────────────── */
const SOCIALS = [
    {
        name: 'Facebook', href: '#',
        gradient: 'linear-gradient(135deg, #1877f2 0%, #0d5bba 100%)',
        icon: (
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
        ),
    },
    {
        name: 'Instagram', href: '#',
        gradient: 'linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
        icon: (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
            </svg>
        ),
    },
    {
        name: 'YouTube', href: '#',
        gradient: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)',
        icon: (
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white"/></svg>
        ),
    },
    {
        name: 'TikTok', href: '#',
        gradient: 'linear-gradient(135deg, #010101 0%, #2f2f2f 100%)',
        icon: (
            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.28 6.28 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.75a8.17 8.17 0 004.78 1.52V6.83a4.85 4.85 0 01-1.01-.14z"/></svg>
        ),
    },
];

/* ── FAQ items ────────────────────────────────────────────── */
const FAQS = [
    {
        q: 'Làm thế nào để bớt hãm?',
        a: 'Chúng tôi sẽ phản hồi trong vòng 48 giờ.',
    },
    {
        q: 'Làm thế nào để bớt hãm?',
        a: 'Chúng tôi sẽ phản hồi trong vòng 48 giờ.',

    },
    {
        q: 'Làm thế nào để bớt hãm?',
        a: 'Chúng tôi sẽ phản hồi trong vòng 48 giờ.',
    },
];

/* ── Component ────────────────────────────────────────────── */
class Contact extends Component {
    state = {
        form: { firstName: '', lastName: '', email: '', phone: '', subject: '', message: '' },
        openFaq: null,
        submitted: false,
        error: '',
    };

    handleField = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({ form: { ...prev.form, [name]: value } }));
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { firstName, email, message } = this.state.form;
        if (!firstName.trim() || !email.trim() || !message.trim()) {
            this.setState({ error: 'Vui lòng điền đầy đủ các trường bắt buộc (*).' });
            return;
        }
        this.setState({ submitted: true, error: '' });
    };

    resetForm = () => {
        this.setState({
            submitted: false,
            form: { firstName: '', lastName: '', email: '', phone: '', subject: '', message: '' },
        });
    };

    toggleFaq = (i) => {
        this.setState(prev => ({ openFaq: prev.openFaq === i ? null : i }));
    };

    render() {
        const { form, submitted, error, openFaq } = this.state;

        return (
            <div className="contact-pg">
                <PageMeta title="Liên hệ" description="Liên hệ với ban tổ chức Vietnam Yosakoi Festival – chúng tôi luôn sẵn sàng hỗ trợ bạn." url="/contact" image="https://vietnamyosakoi.com/images/contact-header-background.jpg" />

                {/* Page header */}
                <div className="page-header contact-pg-header">
                    <div className="page-header-overlay" />
                    <div className="container page-header-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="entry-meta-date">Việt Nam Yosakoi Festival</div>
                                <h1 className="page-header-title">LIÊN HỆ</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

                <div className="ctc-bg-section">

                    {/* Info cards */}
                    <div className="ctc-info-section">
                        <div className="container">
                            <div className="ctc-info-cards">
                                {INFO_CARDS.map((c, i) => (
                                    <div key={i} className="ctc-info-card">
                                        <div className="ctc-icon-circle" style={{ background: c.gradient }}>
                                            {c.icon}
                                        </div>
                                        <div className="ctc-info-body">
                                            <div className="ctc-info-label">{c.label}</div>
                                            {c.lines.map((l, j) => (
                                                <div key={j} className="ctc-info-val">{l}</div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* ── Form + Sidebar ── */}
                    <div className="ctc-main-section">
                        <div className="container">
                            <div className="ctc-main-layout">

                                {/* Form side */}
                                <div className="ctc-form-side">
                                    <div className="entry-title">
                                        <p>GỬI TIN NHẮN</p>
                                        <h2>LIÊN HỆ VỚI CHÚNG TÔI</h2>
                                    </div>
                                    <p className="ctc-lead">
                                        Bạn có câu hỏi về lễ hội, muốn đăng ký thông tin, hay hợp tác tài trợ? 
                                        <br/>
                                        Hãy để lại tin nhắn — chúng tôi sẽ phản hồi trong vòng 24 giờ làm việc.
                                    </p>

                                    {submitted ? (
                                        <div className="ctc-success">
                                            <div className="ctc-success-kanji">桜</div>
                                            <h3>Cảm ơn bạn đã liên hệ!</h3>
                                            <p>Chúng tôi đã nhận được tin nhắn của bạn và sẽ phản hồi qua email sớm nhất có thể.</p>
                                            <button className="ctc-reset-btn" onClick={this.resetForm}>
                                                Gửi tin nhắn khác
                                            </button>
                                        </div>
                                    ) : (
                                        <form className="ctc-form" onSubmit={this.handleSubmit} noValidate>
                                            <div className="ctc-row">
                                                <div className="ctc-field">
                                                    <label className="ctc-label">Họ *</label>
                                                    <input className="ctc-input" type="text" name="firstName" placeholder="Nguyễn" value={form.firstName} onChange={this.handleField} />
                                                </div>
                                                <div className="ctc-field">
                                                    <label className="ctc-label">Tên *</label>
                                                    <input className="ctc-input" type="text" name="lastName" placeholder="Văn A" value={form.lastName} onChange={this.handleField} />
                                                </div>
                                            </div>
                                            <div className="ctc-row">
                                                <div className="ctc-field">
                                                    <label className="ctc-label">Email *</label>
                                                    <input className="ctc-input" type="email" name="email" placeholder="email@example.com" value={form.email} onChange={this.handleField} />
                                                </div>
                                                <div className="ctc-field">
                                                    <label className="ctc-label">Điện thoại</label>
                                                    <input className="ctc-input" type="tel" name="phone" placeholder="0912 345 678" value={form.phone} onChange={this.handleField} />
                                                </div>
                                            </div>
                                            <div className="ctc-field">
                                                <label className="ctc-label">Chủ đề</label>
                                                <input className="ctc-input" type="text" name="subject" placeholder="Tôi muốn hỏi về…" value={form.subject} onChange={this.handleField} />
                                            </div>
                                            <div className="ctc-field">
                                                <label className="ctc-label">Tin nhắn *</label>
                                                <textarea className="ctc-input ctc-textarea" name="message" rows={5} placeholder="Nội dung tin nhắn của bạn…" value={form.message} onChange={this.handleField} />
                                            </div>
                                            {error && <p className="ctc-error">{error}</p>}
                                            <BurstBtn
                                                className="btn btn-img-base btn-img-down"
                                                onClick={() => this.handleSubmit({ preventDefault: () => {} })}
                                            >
                                                Gửi Tin Nhắn
                                            </BurstBtn>
                                        </form>
                                    )}
                                </div>

                                {/* Sidebar */}
                                <aside className="ctc-sidebar">

                                    {/* Social */}
                                    <div className="ctc-card">
                                        <div className="ctc-card-title">
                                            <span className="ctc-card-kanji">桜</span>
                                            Theo Dõi Chúng Tôi
                                        </div>
                                        <div className="ctc-social-grid">
                                            {SOCIALS.map((s) => (
                                                <a
                                                    key={s.name}
                                                    href={s.href}
                                                    className="ctc-social-btn"
                                                    style={{ background: s.gradient }}
                                                    aria-label={s.name}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <span className="ctc-social-icon">{s.icon}</span>
                                                    <span className="ctc-social-name">{s.name}</span>
                                                </a>
                                            ))}
                                        </div>
                                    </div>

                                 

                                    {/* FAQ */}
                                    <div className="ctc-card">
                                        <div className="ctc-card-title">
                                            <span className="ctc-card-kanji">桜</span>
                                            Câu Hỏi Thường Gặp
                                        </div>
                                        <div className="ctc-faqs">
                                            {FAQS.map((f, i) => (
                                                <div
                                                    key={i}
                                                    className={`ctc-faq-item${openFaq === i ? ' ctc-faq-open' : ''}`}
                                                >
                                                    <button
                                                        className="ctc-faq-q"
                                                        onClick={() => this.toggleFaq(i)}
                                                    >
                                                        {f.q}
                                                        <span className="ctc-faq-arrow">{openFaq === i ? '−' : '+'}</span>
                                                    </button>
                                                    <div className="ctc-faq-a">
                                                        <p>{f.a}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </aside>
                            </div>
                        </div>
                    </div>

                    <SakuraSep />
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

            </div>
        );
    }
}

export default Contact;
